import { radii } from "../../primitives/radii";
import type { RadiiTheme } from "../../semantic/radii";

export const baseRadii: RadiiTheme = {
  none: radii.none,
  xs: radii.xs,
  sm: radii.sm,
  md: radii.md,
  lg: radii.lg,
  xl: radii.xl,
  full: radii.full,
  "2xl": radii["2xl"],
  "3xl": radii["3xl"],
};
